import NextImage from 'next/image'
import { jsonToArray } from '@helpers/contentful'
import { getLink } from '@helpers/env'
import { analytics } from '@helpers/analytics'
import styles from './styles.module.scss'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'
import { File } from 'types/contentful/graphQlApi'

type ShoppableCardProps = Card & {
  index: number
  firstTimeUser: boolean
}

const ShoppableCard = ({
  title,
  byline,
  button,
  image,
  index,
  verticalAlignment,
  hideCopy,
  firstTimeUser,
  copyColor = 'light'
}: ShoppableCardProps) => {
  const handleClick = () => {
    analytics('Click', {
      ...button.event,
      label: 'Shoppable',
      type: firstTimeUser ? 'New' : 'Existing',
      action: `Module ${index + 1}`
    })
  }

  return (
    <a
      href={getLink(button.uri)}
      onClick={handleClick}
      className={`${styles.shoppableCard} ${styles[`theme_${copyColor}`]}`}
    >
      <div className={styles.shoppableCard__imageMedia}>
        <NextImage
          src={`https:${image.file.url}`}
          alt={title}
          width={'100'}
          height={'100'}
        />
      </div>
      <div
        className={`${styles.shoppableCard__copyWrapper} ${
          styles[`verticalAlign__${verticalAlignment}`]
        }`}
      >
        {!hideCopy && (
          <div className={styles.shoppableCard__copy}>
            <h3>{title}</h3>
            {!!byline?.trim() && <p>{byline.trim()}</p>}
          </div>
        )}

        <ButtonMinimal
          classes={styles.shoppableCard__imageButton}
          variant="white"
          underlined={true}
          onClick={() => {
            window.location.href = button.uri
          }}
        >
          {button.text}
        </ButtonMinimal>
      </div>
    </a>
  )
}

type CardButton = {
  uri: string
  text: string
  event: {
    label?: string
    category?: string
  }
}

type CardImage = {
  title: string
  file: File
}

type Card = {
  title: string
  byline?: string
  button: CardButton
  image: CardImage
  copyColor: 'light' | 'dark'
  verticalAlignment?: 'center' | 'end'
  hideCopy?: boolean
}

type ShoppableCardsProps = {
  cards: Record<string, Card>
  firstTimeUser: boolean
}

const ShoppableCards = ({ cards, firstTimeUser }: ShoppableCardsProps) => {
  const cardElements = jsonToArray(cards) as Card[]

  return (
    <div className={styles.shoppableCards}>
      <div className={styles.shoppableCards__Wrapper}>
        {cardElements.map(
          (
            {
              title,
              byline,
              button,
              image,
              copyColor,
              verticalAlignment,
              hideCopy
            },
            index
          ) => (
            <ShoppableCard
              key={title}
              title={title}
              byline={byline}
              button={button}
              image={image}
              index={index}
              firstTimeUser={firstTimeUser}
              copyColor={copyColor}
              verticalAlignment={verticalAlignment || 'end'}
              hideCopy={hideCopy || false}
            />
          )
        )}
      </div>
    </div>
  )
}

export default ShoppableCards
